var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33342 1.16667H9.08342V0H7.33342C6.87894 0.00127536 6.43109 0.109124 6.02585 0.314883C5.62062 0.520642 5.26928 0.818576 5.00008 1.18475C4.73088 0.818576 4.37955 0.520642 3.97431 0.314883C3.56907 0.109124 3.12123 0.00127536 2.66675 0L0.916748 0V1.16667H2.66675C3.13088 1.16667 3.576 1.35104 3.90419 1.67923C4.23237 2.00742 4.41675 2.45254 4.41675 2.91667V8.16667H2.08341V9.33333H4.41675V11.0833C4.41675 11.5475 4.23237 11.9926 3.90419 12.3208C3.576 12.649 3.13088 12.8333 2.66675 12.8333H0.916748V14H2.66675C3.12123 13.9987 3.56907 13.8909 3.97431 13.6851C4.37955 13.4794 4.73088 13.1814 5.00008 12.8152C5.26928 13.1814 5.62062 13.4794 6.02585 13.6851C6.43109 13.8909 6.87894 13.9987 7.33342 14H9.08342V12.8333H7.33342C6.86929 12.8333 6.42417 12.649 6.09598 12.3208C5.76779 11.9926 5.58342 11.5475 5.58342 11.0833V9.33333H7.91675V8.16667H5.58342V2.91667C5.58342 2.45254 5.76779 2.00742 6.09598 1.67923C6.42417 1.35104 6.86929 1.16667 7.33342 1.16667Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarret);
export default __webpack_public_path__ + "static/media/carret.05ad0852de9678f7b31fa87977f6dbbf.svg";
export { ForwardRef as ReactComponent };